module.exports = {"pathContext":{"name":"CensusUpdate","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"target","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"INTERFACE","name":"CensusUpdateTarget","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-census-update.json
// module id = 1694
// module chunks = 121326559478583